import { DtoCubeDataResponse } from "@/types/dto-types";
import { SelectedFilters } from "@/routes/Frontend/FuturebilityCockpit/hooks";

export interface AnalyticsProps {
  rawData?: DtoCubeDataResponse;
  currentTestId: string;
  selectedFilters: SelectedFilters | undefined;
}

export enum ViewMode {
  Cube = "cube",
  Challenges = "challenges",
}
